/**
 * Browser storage keys.
 *
 * Namespaced because localStorage is shared across everything served from an
 * origin. An unprefixed 'theme' would collide with anything else on the domain.
 *
 * There is deliberately nothing session-shaped here. This portal holds no
 * credential of any kind: the share token lives in the URL the dentist was
 * emailed, and is never copied into storage. A token in localStorage would
 * outlive the tab, survive the link being withdrawn, and be readable by any
 * script that ever ran on this origin - none of which is true of a URL.
 */
export const STORAGE_KEYS = {
  theme: 'nudent.theme',
} as const;
